import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { Node } from '@rivethealth/data/options';
import { getTooltipFromNode } from './util';

@Component({
  selector: 'single-select-node',
  templateUrl: './single-select-node.component.html',
  styleUrls: ['./single-select-node.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SingleSelectNodeComponent {
  private _displayId: boolean;

  @Input()
  public node: Node;

  @Input()
  public disabled: boolean = false;

  @Input()
  get displayId(): boolean {
    return this._displayId;
  }
  set displayId(displayId: boolean) {
    this._displayId = displayId || false;
  }

  public getTooltipFromNode = getTooltipFromNode;

  public onClicked($event: MouseEvent) {
    if (!this.disabled && !this.node.disabled) {
      this.clicked.emit();
    }
  }

  @Output() clicked = new EventEmitter<void>();
}
